module.exports = require('./helpers/bundle-url').getBundleURL('53zxi') + "logo-dark.bdeff35f.svg";